import { CellContext } from "@tanstack/react-table";
import type { ViewTableFeatures } from "@design-system/ViewTable/core/table";
import { memo } from "react";
import { BillLineItem } from "@common/types/bill";
import { ViewTableCell } from "@design-system/ViewTable/ViewTableCell";

export const DescriptionCell = memo(
    ({ row }: CellContext<ViewTableFeatures, BillLineItem, any>) => {
        const lineItem = row.original;

        return (
            <ViewTableCell>
                {lineItem.description ?? "No description"}
            </ViewTableCell>
        );
    },
);
